import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
var _excluded = ["text"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { Theme } from "../../Background/Theme/Theme";
import { Background } from "../../Background/Background";
import { Button } from "../../../components/Button/Button/Button";
import { Container } from "../../../components/Container/Container/Container";
import { SmallProductSquareList } from "../../../components/List/SmallProductSquareList/SmallProductSquareList";
import { MatchHeight } from "../../../components/Utility/MatchHeight/MatchHeight";
import { Text } from "../../../components/Text/Text/Text";
import { SliceIntroBlock } from "../../../components/Block/SliceIntroBlock/SliceIntroBlock";
import styles from "./SmallProductSquareSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var smallProductSquareSliceAlign = ['left', 'center'];
export var smallProductSquareSliceEyebrowTypogs = ['eyebrow1', 'eyebrow2', 'eyebrow3'];
export var SmallProductSquareSlice = function SmallProductSquareSlice(_ref) {
  var _offerBanner$text, _offerBanner$popup;
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? {
      color: 'none',
      theme: 'lightBackground'
    } : _ref$background,
    _ref$mobileAlign = _ref.mobileAlign,
    mobileAlign = _ref$mobileAlign === void 0 ? 'center' : _ref$mobileAlign,
    cta = _ref.cta,
    eyebrow = _ref.eyebrow,
    footnote = _ref.footnote,
    heading = _ref.heading,
    logo = _ref.logo,
    offerBanner = _ref.offerBanner,
    _ref$productSquareLis = _ref.productSquareList,
    productSquareList = _ref$productSquareLis === void 0 ? [] : _ref$productSquareLis;
  var hasLogo = logo === null || logo === void 0 ? void 0 : logo.image1x;
  var hasEyebrow = eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text;
  var hasHeading = heading === null || heading === void 0 ? void 0 : heading.text;
  var hasOfferBanner = (offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$text = offerBanner.text) === null || _offerBanner$text === void 0 ? void 0 : _offerBanner$text.text) || (offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$popup = offerBanner.popup) === null || _offerBanner$popup === void 0 ? void 0 : _offerBanner$popup.title);
  var handleClasses = function handleClasses(originalClass) {
    return classnames(originalClass, mobileAlign ? styles["mobileAlign".concat(_capitalize(mobileAlign))] : {});
  };
  var introData = hasLogo || hasEyebrow || hasHeading || hasOfferBanner ? {
    align: align,
    className: styles.introBlock,
    icon: _objectSpread(_objectSpread({}, logo), {}, {
      className: handleClasses(styles.asideLogo)
    }),
    eyebrow: _objectSpread(_objectSpread({}, eyebrow), {}, {
      className: handleClasses(styles.eyebrow)
    }),
    heading: _objectSpread(_objectSpread({}, heading), {}, {
      className: handleClasses(styles.headline)
    }),
    offerBanner: _objectSpread(_objectSpread({}, offerBanner), {}, {
      className: handleClasses(styles.offerBanner)
    })
  } : null;

  // Display product squares to right of logo / offer banner if space allows.
  var isHorizontalLayout = productSquareList && productSquareList.length < 3 && (hasLogo || hasHeading || (offerBanner === null || offerBanner === void 0 ? void 0 : offerBanner.popup) || (offerBanner === null || offerBanner === void 0 ? void 0 : offerBanner.text));
  var renderCTA = function renderCTA(cta) {
    if (!cta || !cta.text) {
      return null;
    }
    var text = cta.text,
      otherProps = _objectWithoutProperties(cta, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, otherProps), {}, {
      children: text
    }));
  };
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: styles.wrapper,
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: classnames(styles.topWrapper, {
            [styles.horizontal]: isHorizontalLayout
          }),
          children: [/*#__PURE__*/_jsx("div", {
            className: classnames(styles.asideWrapper, styles["asideWrapper".concat(align)]),
            children: introData && /*#__PURE__*/_jsx("div", {
              className: classnames(styles.aside, styles["aside".concat(align)]),
              children: /*#__PURE__*/_jsx(SliceIntroBlock, _objectSpread({}, introData))
            })
          }), /*#__PURE__*/_jsx("div", {
            className: styles.productSquaresWrapper,
            children: /*#__PURE__*/_jsx(MatchHeight, {
              bypass: "responsive",
              breakpoint: "medium",
              children: /*#__PURE__*/_jsx(Theme, {
                theme: "lightBackground",
                children: /*#__PURE__*/_jsx(SmallProductSquareList, {
                  products: productSquareList
                })
              })
            })
          })]
        }), footnote && /*#__PURE__*/_jsx(Text, {
          className: styles.footnote,
          typog: "bodycopySmall",
          richText: true,
          children: footnote
        }), (cta === null || cta === void 0 ? void 0 : cta.text) && (cta === null || cta === void 0 ? void 0 : cta.url) && /*#__PURE__*/_jsx("div", {
          className: styles.cta,
          children: renderCTA(cta)
        })]
      })
    })
  }));
};